import { loadable } from '@change-corgi/core-react/loadable';

import type { AppRoute } from '#src/shared/routes';

import { Loading } from '#src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'admin-offsite-fulfillment',
		path: '/admin/p/:slug/offsite_fulfillment',
		component: loadable(
			async () => import(/* webpackChunkName: "pages/admin-petition-offsiteFulfillment" */ './index'),
			{
				exportName: 'AdminOffsiteFulfillment',
				fallback: Loading,
			},
		),
		frame: true,
		restrictedAccess: {
			authOnly: true,
			role: ['support', 'staff'],
		},
		ssr: {
			// switch this to true to enable SSR
			enabled: false,
			seo: false,
		},
	},
];
